import Button from "@mui/material/Button";
import { Gavel, AccountBalance } from "@mui/icons-material";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import { Box } from "@mui/material";

import { useState, useEffect } from "react";
import Config from "../config.json";
import MaterialsSimple from "./MaterialsSimple";

function Beranda() {
  const url_data = Config.api_domain + "/seleksi/active/";
  const [data, setData] = useState(null);
  const [berandaVisits, setBerandaVisits] = useState(null);

  useEffect(() => {
    // Fetch data dari backend
    try {
      const requestOptions = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      };

      fetch(url_data, requestOptions)
        .then((res) => res.json())
        .then((data) => setData(data));
    } catch (error) {
      alert(`Error ${error}`);
    }

    // ✅ CounterAPI khusus untuk halaman Beranda
  }, []);

  return (
    <>
      <div
        style={{
          width: "100%",
          height: "80vh",
          position: "relative",
          background: "#f5f8fd url(./banner.jpg) center top no-repeat",
          backgroundSize: "cover",
          display: "flex",
          alignItems: "center",
          justifyContent: "left",
          overflow: "hidden"
        }}
      >
        {/* Modern overlay gradient */}
        <div 
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'linear-gradient(135deg, rgba(46, 46, 46, 0.3) 0%, rgba(0, 0, 0, 0.1) 100%)',
            zIndex: 1
          }}
        />
        
        <div className="bg-landing" style={{ position: 'relative', zIndex: 2 }}>
          <Box
            sx={{
              backgroundColor: "rgba(255, 255, 255, 0.95)",
              backdropFilter: "blur(10px)",
              margin: "100px 30px 30px 30px",
              padding: "40px",
              borderRadius: "20px",
              boxShadow: "0 20px 60px rgba(0, 0, 0, 0.15), 0 0 0 1px rgba(255, 255, 255, 0.2)",
              border: "1px solid rgba(255, 255, 255, 0.3)",
              maxWidth: "800px",
              transition: "all 0.3s ease",
              "&:hover": {
                transform: "translateY(-5px)",
                boxShadow: "0 30px 80px rgba(0, 0, 0, 0.2)"
              }
            }}
          >
            <Typography 
              variant="h4"
              sx={{
                fontWeight: 700,
                background: "linear-gradient(135deg, #2e2e2e 0%, #546e7a 100%)",
                backgroundClip: "text",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                lineHeight: 1.3,
                fontSize: { xs: "1.75rem", md: "2.125rem" },
                textShadow: "none"
              }}
            >
              Integrated Land Administration and Spatial Planning (ILASP) Project
            </Typography>
            
            {/* Modern CTA buttons */}
            <Box sx={{ 
              display: 'flex', 
              gap: 2, 
              mt: 4, 
              flexWrap: 'wrap',
              alignItems: 'center'
            }}>
              <Button
                variant="contained"
                startIcon={<Gavel />}
                href="https://spseicb.lkpp.go.id/spseicb/"
                target="_blank"
                rel="noopener noreferrer"
                sx={{
                  backgroundColor: '#2e2e2e',
                  color: 'white',
                  padding: '12px 24px',
                  fontSize: '1rem',
                  fontWeight: 600,
                  borderRadius: '12px',
                  textTransform: 'none',
                  boxShadow: '0 8px 24px rgba(46, 46, 46, 0.3)',
                  '&:hover': {
                    backgroundColor: '#1a1a1a',
                    transform: 'translateY(-2px)',
                    boxShadow: '0 12px 32px rgba(46, 46, 46, 0.4)',
                  },
                  transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)'
                }}
              >
                SPSE ICB
              </Button>
              
              <Button
                variant="outlined"
                startIcon={<AccountBalance />}
                href="https://spse.inaproc.id/big/"
                target="_blank"
                rel="noopener noreferrer"
                sx={{
                  borderColor: '#2e2e2e',
                  color: '#2e2e2e',
                  padding: '12px 24px',
                  fontSize: '1rem',
                  fontWeight: 600,
                  borderRadius: '12px',
                  textTransform: 'none',
                  borderWidth: '2px',
                  '&:hover': {
                    borderColor: '#2e2e2e',
                    backgroundColor: 'rgba(46, 46, 46, 0.08)',
                    borderWidth: '2px',
                    transform: 'translateY(-2px)',
                  },
                  transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)'
                }}
              >
                SPSE INAPROC BIG
              </Button>
            </Box>
            
            {/* Tampilkan counter khusus beranda */}
          </Box>
        </div>
      </div>

      <div style={{ width: "100%" }}>
        <Container sx={{ 
          padding: "2em 1em 1em 1em",
          position: "relative"
        }}>
          {/* Modern decorative element */}
          <Box
            sx={{
              position: "absolute",
              top: -20,
              left: "50%",
              transform: "translateX(-50%)",
              width: 60,
              height: 4,
              backgroundColor: "#2e2e2e",
              borderRadius: 2,
              opacity: 0.3
            }}
          />
          
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
            }}
          >
            <div
              style={{
                width: "33%",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              {/* Content bisa ditambahkan di sini kalau ada */}
            </div>
          </div>
        </Container>
      </div>

      <MaterialsSimple />
      
      {/* Modern CSS animations */}
      <style jsx>{`
        .bg-landing {
          animation: slideInLeft 0.8s cubic-bezier(0.4, 0, 0.2, 1);
        }
        
        @keyframes slideInLeft {
          from {
            opacity: 0;
            transform: translateX(-50px);
          }
          to {
            opacity: 1;
            transform: translateX(0);
          }
        }
      `}</style>
    </>
  );
}

export default Beranda;